module.exports = __webpack_public_path__ + "static/media/ghettoradio.dad817cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ghettoradio.png
// module id = 589
// module chunks = 0